import React, {Component} from 'react';
import logo from "../../img/logo.png";
import "../../style/hamburgerMenu.css";
import {NavLink} from 'react-router-dom';
import MainContext from '../../contexts/ContextProvider';

class HamburgerMenu extends Component {
    state = {}
    static contextType = MainContext;

    closeIfMobile = () => {
        if (window.innerWidth <= 768) {
            this.context.handleSidebar();
        }
    };

    render() {
        const role = localStorage.getItem('role');
        const username = localStorage.getItem('username') || '';
        const roleLabel = role === 'MANAGER' ? 'مدیر' : role === 'SUPERVISOR' ? 'سرپرست' : 'کاربر';

        return (
            <div className='sidebar' style={
                this.context.activeMenu ? {display: "none"} : {display: "flex"}
            }>
                <div className="sidebar-top">
                    <div className='close-icon'>
                        <button type="button" aria-label="بستن منو" onClick={() => this.context.handleSidebar()}>
                            <i className='bi bi-x'/>
                        </button>
                    </div>
                    <div className='logo-container'>
                        <img src={logo} className="sidenav-logo" alt="لوگو"/>
                        <div className="sidebar-brand-text">
                            <strong>سعادت پرتال</strong>
                            <span>مدیریت خوابگاه</span>
                        </div>
                    </div>
                    <div className="sidebar-user">
                        <div className="sidebar-user-avatar" aria-hidden="true">
                            {(username || roleLabel).slice(0, 1)}
                        </div>
                        <div className="sidebar-user-meta">
                            <span className="sidebar-user-name">{role === 'MANAGER' ? 'مدیر سیستم' : username || 'کاربر'}</span>
                            <span className="sidebar-user-role">{roleLabel}</span>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav" aria-label="منوی اصلی">
                    <div className="nav-section">
                        <div className="nav-section-title">داشبورد</div>
                        <ul>
                            <li className='sidenav-item'>
                                <NavLink end activeClassName='active-sidebar' to="/dashboard" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-speedometer2"></i>
                                    آمار
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="nav-section">
                        <div className="nav-section-title">مالی</div>
                        <ul>
                            <li className='sidenav-item'>
                                <NavLink activeClassName='active-sidebar' to="/dashboard/payment" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-calculator"></i>
                                    ثبت فاکتور
                                </NavLink>
                            </li>
                            {role === 'MANAGER' ? (
                                <li className='sidenav-item'>
                                    <NavLink activeClassName='active-sidebar' to="/dashboard/PaymentHistory" className='sidenav-link'
                                             onClick={this.closeIfMobile}>
                                        <i className="bi bi-receipt"></i>
                                        صورتحساب
                                    </NavLink>
                                </li>
                            ) : null}
                        </ul>
                    </div>

                    <div className="nav-section">
                        <div className="nav-section-title">ارتباطات</div>
                        <ul>
                            {role === 'SUPERVISOR' ? (
                                <li className='sidenav-item'>
                                    <NavLink activeClassName='active-sidebar' to="/dashboard/Request" className='sidenav-link'
                                             onClick={this.closeIfMobile}>
                                        <i className="bi bi-inbox"></i>
                                        درخواست
                                    </NavLink>
                                </li>
                            ) : null}
                            {role === 'MANAGER' ? (
                                <li className='sidenav-item'>
                                    <NavLink activeClassName='active-sidebar' to="/dashboard/Request-manager" className='sidenav-link'
                                             onClick={this.closeIfMobile}>
                                        <i className="bi bi-envelope"></i>
                                        درخواست (مدیریت)
                                    </NavLink>
                                </li>
                            ) : null}
                            <li className='sidenav-item'>
                                <NavLink activeClassName='active-sidebar' to="/dashboard/contacts" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-person-rolodex"></i>
                                    مخاطبین
                                </NavLink>
                            </li>
                            <li className='sidenav-item'>
                                <NavLink activeClassName='active-sidebar' to="/dashboard/CallHistory" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-telephone"></i>
                                    تاریخچه تماس‌ها
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="nav-section">
                        <div className="nav-section-title">عملیات</div>
                        <ul>
                            <li className='sidenav-item'>
                                <NavLink activeClassName='active-sidebar' to="/dashboard/Calender" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-calendar3"></i>
                                    تقویم
                                </NavLink>
                            </li>
                            <li className='sidenav-item'>
                                <NavLink activeClassName='active-sidebar' to="/dashboard/taskManagement" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-clipboard2-check"></i>
                                    مدیریت وظایف
                                </NavLink>
                            </li>
                            <li className="sidenav-item">
                                <NavLink activeClassName='active-sidebar' to="/dashboard/Inventory" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-boxes"></i>
                                    انبار
                                </NavLink>
                            </li>
                            <li className='sidenav-item'>
                                <NavLink to="/dashboard/personnel" className='sidenav-link' activeClassName='active-sidebar'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-people"></i>
                                    پرسنل
                                </NavLink>
                            </li>
                            <li className="sidenav-item">
                                <NavLink activeClassName='active-sidebar' to="/dashboard/PresenceAbsence" className='sidenav-link'
                                         onClick={this.closeIfMobile}>
                                    <i className="bi bi-moon-stars"></i>
                                    نوبت نظافت شبانه
                                </NavLink>
                            </li>
                            {role === 'MANAGER' ? (
                                <li className="sidenav-item">
                                    <NavLink activeClassName='active-sidebar' to="/dashboard/log" className='sidenav-link'
                                             onClick={this.closeIfMobile}>
                                        <i className="bi bi-clock-history"></i>
                                        تاریخچه کارها
                                    </NavLink>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

export default HamburgerMenu;
